var _rect, _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _g6, _path9, _g7, _path10, _g8, _path11, _g9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 114,
    viewBox: "0 0 100 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 8,
    fill: "#133F7A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3312 78.5H79.75L48.0295 11H37.2292V11.5182C40.4661 13.5493 40.6982 16.3596 38.7473 21.0876L12.25 78.5H19.5695L28.4151 58.2795H60.3598L69.3312 78.5ZM30.6596 52.8673L44.1437 22.1078L57.8349 52.8673H30.6596Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92 4C92 6.20571 93.7943 8 96 8C98.2286 8 100 6.20571 100 4C100 1.79429 98.2286 0 96 0C93.7943 0 92 1.79429 92 4ZM92.9143 4C92.9143 2.24 94.2971 0.8 96 0.8C97.7143 0.8 99.0743 2.22857 99.0743 4C99.0743 5.77143 97.7143 7.2 96 7.2C94.2971 7.2 92.9143 5.76 92.9143 4ZM94.5371 5.96571H95.4514V4.41143H95.7143C96.5486 4.41143 96.5829 4.74286 96.5943 5.05143C96.6171 5.66857 96.5829 5.77143 96.7429 5.96571H97.68C97.52 5.74857 97.5543 5.63429 97.52 5.01714C97.4971 4.64 97.4629 4.17143 96.9486 4.06857V4.04571C97.5657 3.85143 97.6229 3.38286 97.6229 3.13143C97.6229 2.88 97.6229 1.96571 96.2857 1.96571H94.5371V5.96571ZM95.4514 2.67429H96.0571C96.1943 2.67429 96.6971 2.68571 96.6971 3.18857C96.6971 3.42857 96.5829 3.70286 96.1371 3.70286H95.4514V2.67429Z",
    fill: "#133F7A"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_6335)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_48_6335",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 98,
    width: 8,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5615 98.8999V99.7639H76.1297V103.544H80.9616V104.386H76.1297V108.753H81.9001V109.7H74.7001V98.8999H81.5615Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_48_6335)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4499 96.6499H84.1499V111.95H72.4499V96.6499Z",
    fill: "#133F7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_48_6335",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 98,
    width: 11,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7691 98.8999L57.4571 108.037L61.0567 98.8999H62.1002L57.698 109.7H56.6545L52.2002 98.8999H53.7691Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_48_6335)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.95 96.6499H64.3499V111.95H49.95V96.6499Z",
    fill: "#133F7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_48_6335",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 98,
    width: 10,
    height: 13
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6477 98.6876C37.502 98.6876 38.7304 98.9275 39.4363 99.1901V100.304L39.4069 100.328C38.6931 99.6968 37.4696 99.4673 36.4344 99.4673C33.9929 99.4673 32.0489 101.325 32.0489 104.247C32.0489 107.729 34.1683 109.092 36.6422 109.114C37.6438 109.121 38.9571 108.936 39.71 108.14L39.7339 108.165V109.533C38.8154 109.798 37.5442 110.042 36.5756 110.04C33.5065 110.027 30.5352 108.248 30.5352 104.409C30.5352 101.524 32.8147 98.6876 36.6477 98.6876Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_48_6335)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2856 96.4375H41.9843V112.29H28.2856V96.4375Z",
    fill: "#133F7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_48_6335",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 98,
    width: 10,
    height: 13
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.304 98.941V105.929C43.304 107.511 43.8124 109.212 46.2386 109.212C48.5224 109.212 49.5076 107.853 49.5076 105.839V98.941H50.5043V105.808C50.5043 108.166 48.9557 110.038 46.2441 110.038C43.5344 110.038 41.8697 108.395 41.8697 106.003V98.941H43.304Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_48_6335)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6196 96.691H52.7542V112.288H39.6196V96.691Z",
    fill: "#133F7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_48_6335",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 98,
    width: 12,
    height: 12
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3692 98.8624L30.2979 109.784H28.6791L27.2851 106.512H22.3215L20.9477 109.784H19.8098L23.9269 100.494C24.2307 99.7296 24.194 99.2743 23.691 98.9463V98.8624H25.3692ZM24.7837 100.649L22.6766 105.67H26.9239L24.7837 100.649Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_48_6335)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5596 96.6125H32.5478V112.034H17.5596V96.6125Z",
    fill: "#133F7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_48_6335",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 98,
    width: 10,
    height: 13
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.073 98.941V105.929C65.073 107.511 65.5821 109.212 68.0077 109.212C70.2915 109.212 71.2766 107.853 71.2766 105.839V98.941H72.274V105.808C72.274 108.166 70.7248 110.038 68.0138 110.038C65.3046 110.038 63.64 108.395 63.64 106.003V98.941H65.073Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_48_6335)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3899 96.691H74.5239V112.288H61.3899V96.691Z",
    fill: "#133F7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_48_6335",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 98,
    width: 11,
    height: 12
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00309 98.8903L5.32396 107.724H5.38324L8.76339 98.8903H10.7514V109.672H9.41119V103.042C9.41119 102.305 9.44602 101.368 9.51447 100.232H9.45519L5.86175 109.672H4.75012L1.20007 100.218H1.1414C1.21535 101.004 1.25141 101.975 1.25141 103.131V109.672H0.000427246V98.8903H2.00309Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_48_6335)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.24921 96.6404H13.0018V111.922H-2.24921V96.6404Z",
    fill: "#133F7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_48_6335",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 101,
    width: 8,
    height: 13
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6531 101.574L15.3991 106.183C15.767 107.187 15.9925 107.921 16.0763 108.389H16.1355C16.1795 108.207 16.2798 107.866 16.4374 107.367C16.5945 106.868 16.7265 106.469 16.8347 106.169L18.4774 101.574H19.9056L16.4222 110.793C16.0836 111.688 15.6815 112.329 15.2146 112.718C14.7483 113.106 14.1714 113.3 13.4839 113.3C13.1153 113.3 12.7499 113.259 12.3869 113.175V112.12C12.6319 112.179 12.9271 112.209 13.2706 112.209C13.6929 112.209 14.0516 112.092 14.3456 111.859C14.6401 111.625 14.8809 111.265 15.0673 110.778L15.4871 109.701L12.2323 101.574H13.6531Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_48_6335)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98245 99.3242H22.1558V115.55H9.98245V99.3242Z",
    fill: "#133F7A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_48_6335",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 98,
    width: 7,
    height: 7
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5385 98.186C87.4828 98.186 88.2849 98.5169 88.9466 99.1796C89.6064 99.8424 89.9367 100.64 89.9367 101.576C89.9367 102.512 89.6064 103.306 88.9466 103.958C88.2849 104.608 87.4828 104.936 86.5385 104.936C85.593 104.936 84.792 104.608 84.1303 103.958C83.4674 103.306 83.1381 102.512 83.1381 101.576C83.1381 100.64 83.4674 99.8424 84.1303 99.1796C84.792 98.5169 85.593 98.186 86.5385 98.186ZM86.5385 98.7083C85.7437 98.7083 85.0673 98.9903 84.5095 99.5531C83.9526 100.115 83.6742 100.79 83.6742 101.576C83.6742 102.362 83.9557 103.036 84.5167 103.598C85.0798 104.161 85.753 104.444 86.5385 104.444C87.3228 104.444 87.9971 104.161 88.5581 103.598C89.1212 103.036 89.3996 102.362 89.3996 101.576C89.3996 100.79 89.1222 100.115 88.5664 99.5531C88.0085 98.9903 87.3332 98.7083 86.5385 98.7083ZM86.552 99.6499C86.9499 99.6499 87.2854 99.7404 87.5597 99.9256C87.8319 100.11 87.9691 100.391 87.9691 100.769C87.9691 101.327 87.6761 101.67 87.0901 101.8L88.1186 103.471H87.2834L86.3888 101.874H85.8974V103.471H85.2117V99.6499H86.552ZM86.5229 100.231H85.8974V101.322H86.4481C87.0049 101.322 87.2834 101.132 87.2834 100.755C87.2834 100.405 87.0299 100.231 86.5229 100.231Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_48_6335)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.8884 95.9359H92.187V107.186H80.8884V95.9359Z",
    fill: "#133F7A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_6335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 15.3,
    fill: "white",
    transform: "translate(0 98)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVertical);
export default __webpack_public_path__ + "static/media/logo-vertical.7b78964a7e50602b95d74daf3b73c877.svg";
export { ForwardRef as ReactComponent };